import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import classNames from 'classnames';
import { Collapse } from 'react-collapse';
import Icon from '@helsenorge/designsystem-react/components/Icon';
import ChevronDown from '@helsenorge/designsystem-react/components/Icons/ChevronDown';
import ChevronUp from '@helsenorge/designsystem-react/components/Icons/ChevronUp';
import Loader from '@helsenorge/designsystem-react/components/Loader';
import NotificationPanel from '@helsenorge/designsystem-react/components/NotificationPanel';
import PortableText from '@helsenorge/core-cms/richtext';
import { theme } from '@helsenorge/designsystem-react';
import { trackProsesshjelp } from '@helsenorge/framework-utils/adobe-analytics';
export class Seksjon extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: this.props.expanded,
        };
        this.toggleExpanded = this.toggleExpanded.bind(this);
        this.removeSeksjonClick = this.removeSeksjonClick.bind(this);
    }
    toggleExpanded() {
        if (this.props.toggleExpanded && this.props.seksjon) {
            if (this.props.seksjon.overskrift) {
                trackProsesshjelp('Prosesshjelp', 'Hjelp', this.props.seksjon.overskrift, !this.props.expanded ? 'Open' : 'Close');
            }
            this.props.toggleExpanded(this.props.seksjon.hjelpetekstId, this.props.seksjon.tjenesteNavn);
        }
    }
    removeSeksjonClick(event) {
        if (event !== undefined) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (this.props.removeSeksjon && this.props.seksjon && this.props.seksjon.hjelpetekstId && this.props.seksjon.tjenesteNavn) {
            this.props.removeSeksjon(this.props.seksjon.hjelpetekstId, this.props.seksjon.tjenesteNavn);
        }
    }
    render() {
        const { resources, id, seksjon, expanded } = this.props;
        if (!seksjon || !resources) {
            return null;
        }
        let errorMessage;
        let seksjonComponent;
        const loader = seksjon.loading ? _jsx(Loader, { center: true, size: 'medium' }) : undefined;
        if (seksjon.error) {
            errorMessage = (_jsx(NotificationPanel, { label: resources.prosessHjelpError, variant: 'error', children: _jsx("p", { children: resources.prosessHjelpErrorDescription }) }));
        }
        else {
            const sectionClasses = classNames('step', { open: expanded });
            seksjonComponent = (_jsxs("section", { className: sectionClasses, children: [_jsx("div", { className: "org_helpdrawer__draweraccordionstepheader", children: _jsx("h2", { children: _jsxs("button", { type: "button", onClick: this.toggleExpanded, className: "org_helpdrawer__draweraccordionsteptitle", "aria-expanded": expanded, "aria-controls": id, children: [_jsx(Icon, { svgIcon: expanded ? ChevronUp : ChevronDown, color: theme.palette.blueberry700 }), this.props.seksjon ? this.props.seksjon.overskrift : ''] }) }) }), _jsx("div", { id: id, children: _jsx(Collapse, { isOpened: !!expanded, children: _jsx("div", { children: _jsx("div", { className: "org_helpdrawer__draweraccordionstepcontents", children: seksjon.brodtekst?.length && _jsx(PortableText, { value: seksjon.brodtekst }) }) }) }) })] }));
        }
        return (_jsxs("div", { className: "org_helpdrawer__draweraccordion", children: [errorMessage, seksjonComponent, loader] }));
    }
}
Object.defineProperty(Seksjon, "defaultProps", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: {
        resources: undefined,
    }
});
